import { Grid, TextField } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import { MobileNumberField } from "../../../components/common/form/MobileNumberField";
import UpperCaseTextField from "../../../modules/common/shared/components/UpperCaseTextField";
import { Person } from "../types";

const DOB_FORMAT = "DD-MMM-YYYY";

type PersonFieldsProps = {
  value: Person;
  onChange: (value: Person) => void;
};

export default function PersonFields({ value, onChange }: PersonFieldsProps) {
  return (
    <>
      <Grid>
        <UpperCaseTextField value={value.name} setValue={(name) => onChange({ ...value, name })} label="Name" required={true} />
      </Grid>
      <Grid>
        <DatePicker
          label="Date of Birth"
          format={DOB_FORMAT}
          value={value.dob ? dayjs(value.dob, DOB_FORMAT) : null}
          onChange={(newValue) => onChange({ ...value, dob: newValue ? newValue.format(DOB_FORMAT) : "" })}
          slotProps={{ textField: { size: "small", fullWidth: true } }}
        />
      </Grid>
      <Grid>
        <MobileNumberField
          label="Mobile No"
          value={value.mobileNo}
          onChange={(mobileNo) => onChange({ ...value, mobileNo })}
          required={false}
          fullWidth
        />
      </Grid>
      <Grid>
        <TextField
          size="small"
          fullWidth
          label="Email"
          type="email"
          value={value.email || ""}
          onChange={(e) => onChange({ ...value, email: e.target.value })}
        />
      </Grid>
      <Grid>
        <TextField
          size="small"
          fullWidth
          label="Qualification"
          value={value.qualification || ""}
          onChange={(e) => onChange({ ...value, qualification: e.target.value })}
        />
      </Grid>
      <Grid>
        <TextField
          size="small"
          fullWidth
          label="Occupation"
          value={value.occupation || ""}
          onChange={(e) => onChange({ ...value, occupation: e.target.value })}
        />
      </Grid>
      <Grid>
        <TextField
          size="small"
          fullWidth
          label="Monthly Income"
          type="number"
          value={value.monthlyIncome ?? ""}
          onChange={(e) => onChange({ ...value, monthlyIncome: e.target.value === "" ? undefined : Number(e.target.value) })}
        />
      </Grid>
    </>
  );
}
